import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, InverseButton, LoadingWrapper, PageTitle } from 'react-fast-ui';
import PropTypes from 'prop-types';
import DAO from '../dao/DAO';
import actions from '../actions/actionTypes';
import AccountSummaryDetails from './AccountSummaryDetails';
import _ from 'underscore';

const mapStateToProps = (store) => ({
  team: store.team,
  licensedProducts: store.licensedProducts,
  accountSummary: store.accountSummary,
});

class AccountSummaryPage extends Component {

  static contextTypes = {
    dao: PropTypes.instanceOf(DAO),
    ngUser: PropTypes.object,
    onError: PropTypes.func,
    onSuccess: PropTypes.func,
  };

  state = {
    loadingAccountSummary: (null: ?Promise),
    isEditing: true,
  }

  componentDidMount() {
    this.fetchAccountSummary();
  }

  fetchAccountSummary = () => {
    const { dao, ngUser, onError } = this.context;
    const { dispatch } = this.props;
    const { loadingAccountSummary: pendingPromise } = this.state;
    const loadingAccountSummary = dao.account.fetchAccountSummary(ngUser.accountId)
      .then((accountSummary) => {
        dispatch({ type: actions.GET_ACCOUNT_SUMMARIES_SUCCESS, accountSummary });
        this.setState({ loadingAccountSummary: null });
      })
      .catch(onError);

    this.setState({ loadingAccountSummary });
  }

  enableEditMode = () => {
    this.setState({ isEditing: false });
  }

  onSave = (account) => {
    const { dao, ngUser, onError, onSuccess } = this.context;
    const { dispatch } = this.props;
    const { loadingAccountSummary: pendingPromise } = this.state;
    const loadingAccountSummary = dao.account.updateAccountSummary(account, ngUser.accountId)
      .then((accountSummary) => {
        dispatch({ type: actions.GET_ACCOUNT_SUMMARIES_SUCCESS, accountSummary });
        this.setState({ loadingAccountSummary: null });
        onSuccess('Account Updated Successfully.');
      })
      .catch(onError);

    this.setState({ loadingAccountSummary });
  }

  render() {
    const { team, accountSummary } = this.props;
    const { loadingAccountSummary, isEditing } = this.state;
    const primaryColor = `#${team.getPrimaryColor()}`;
    const borderDisabled = isEditing ? `2px solid ${primaryColor}` : '2px solid #FFFFFF';
    return (
      <PageTitle title='Account Summary'>
        <div className="adminPortal">
          <header
            style={{ minHeight: 40, borderBottom: '1px solid #d8d8d8' }}>
            <div className="mg-top-sm" style={{ right: '44px', position: 'absolute' }}>
              <InverseButton
                className="mg-left-md btn-primary-admin"
                onClick={() => this.setState({ isEditing: !isEditing })}
                style={{ backgroundColor: `${primaryColor}` }}>
                <Icon name={isEditing ? 'edit' : 'check'}/>
                <span className="mg-left-md" id="editSaveAccountButton">
                  {isEditing ? 'EDIT ACCOUNT' : 'SAVE ACCOUNT'}
                </span>
              </InverseButton>
            </div>
          </header>
          <div className="display-inline-block full-width" style={{ backgroundColor: '#fafafa' }}>
            <main style={{ padding: '0px 44px 20px' }}>
              <section className="tile-pill pd-md mg-bottom-lg mg-top-xl">
                <div>
                  <header
                    style={{
                      width: '100%',
                      borderBottom: borderDisabled,
                      fontFamily: '"Futura PT W01 Bold", sans-serif',
                      textTransform: 'uppercase',
                      fontSize: 23,
                      borderTopLeftRadius: '0.3em',
                      borderTopRightRadius: '0.3em'
                    }}>
                    <div
                      className="display-flex align-items-center justify-content-space-between"
                      style={{ paddingBottom: 6 }}>
                      Account Details
                    </div>
                  </header>
                  <LoadingWrapper loading={Boolean(loadingAccountSummary)}>
                    {!_.isEmpty(accountSummary) &&
                    <AccountSummaryDetails
                      accentColor={primaryColor}
                      isEditing={isEditing}
                      accountSummary={accountSummary}
                      onSave={this.onSave}
                      enableEditMode={this.enableEditMode}
                    />
                    }
                  </LoadingWrapper>
                </div>
              </section>
            </main>
          </div>
        </div>
      </PageTitle>
    );
  }
}

export default connect(mapStateToProps)(AccountSummaryPage);